<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <Header />
    <HomeSideMenu/>
    <div class="banner-wrap">
      <Banner class="banner" />
    </div>
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import HomeSideMenu from '../components/HomeSideMenu';
export default {
  name: "HomeLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Banner,
    Footer,
    HomeSideMenu
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>
<style>
  a *{
    transition: all 0.1s ease;
  }
</style>
<style lang="less" scoped>
.container {
  .banner-wrap {
    .banner-bg{
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: 20px auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    max-width: 1300px;
    margin: 20px auto;
    padding: 20px 60px 100px 60px;
    background: url(../assets/content-bg.png) no-repeat;
    background-size: 100% 100%;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  background: url(../assets/bg2.jpg);
}
.mobile {
  .home{
    padding: 20px 10px 20px 10px;
  }
}
</style>